import React from "react";
import { Calendar, ExternalLink } from "lucide-react";
import { useSite } from "../context/SiteContext";

export default function Booking() {
  const { site } = useSite();
  if (!site?.booking_url) return null;

  return (
    <section id="book" className="relative py-24 md:py-32 bg-[#FDFBF7]" data-testid="booking-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 mb-12 md:mb-16 items-end">
          <div className="md:col-span-7">
            <p className="overline text-[#9F5C45] mb-6">06 — Book online</p>
            <h2 className="font-serif font-light text-[#1C1917] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Pick a time that <em className="italic text-[#3A5A40]">feels right.</em>
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9">
            <p className="text-[#57534E] text-base md:text-lg leading-relaxed">
              See real-time availability and book your first session without a single phone call.
            </p>
          </div>
        </div>

        <div className="border border-[#E2DCD0] bg-white overflow-hidden">
          <iframe
            src={site.booking_url}
            title="Book a session"
            data-testid="booking-iframe"
            className="w-full h-[760px] block"
            loading="lazy"
          />
        </div>

        <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-[#57534E]">
          <p className="flex items-center gap-2">
            <Calendar className="w-4 h-4 text-[#3A5A40]" strokeWidth={1.5} />
            Powered by your booking calendar.
          </p>
          <a
            href={site.booking_url}
            target="_blank"
            rel="noreferrer"
            data-testid="booking-fullscreen"
            className="inline-flex items-center gap-2 hover:text-[#3A5A40] transition-colors"
          >
            Open in a new window <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </section>
  );
}
